import { Validator } from 'components/LWForm';

export const INITIAL_FORM_VALUES = {
	cancellation_reason: '',
	additional_info: '',
};

export const INITIAL_FORM_ERRORS = {
	cancellation_reason: '',
};

export const ADDON_FORM_VALIDATOR: Record<string, Validator> = {
	cancellation_reason: (value) => {
		if (value === '') return 'Please select a cancellation reason';
		return '';
	},
};
